<page-toolbar [pageActions]="pageActions" [title]="pipeImport ? pipeImport.title : title"></page-toolbar>

<mat-progress-bar *ngIf="isLoading || !pipeImport" mode="indeterminate"></mat-progress-bar>

<page-content *ngIf="!isLoading && !!pipeImport">
  <mat-card appearance="outlined">
    <mat-card-title>General</mat-card-title>
    <json-content-table *ngIf="!isLoading && pipeImport" [displayStyle]="'detail'" [json]="contentTableJson">
    </json-content-table>
  </mat-card>
  <mat-card appearance="outlined" *ngIf="uploadedFiles">
    <mat-card-title>Uploaded Files</mat-card-title>
    <mat-card-content>
      <div *ngFor="let file of uploadedFiles" class="uploaded-file">
        <div class="date">{{file.LastModified | date: 'dd.MM.yyyy - HH:mm'}}</div>
        <a (click)="downloadFile(file)">{{getFileName(file)}}</a>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined" *ngFor="let module of pipeImport.modules">
    <mat-card-title>{{module.group}} -> {{module.module}}</mat-card-title>
    <mat-card-content>
      <br>
      <ngx-json-viewer [expanded]="true" [json]="module.data"></ngx-json-viewer>
    </mat-card-content>
  </mat-card>
</page-content>
